import React, { useState } from 'react';
import './SanskritKeyboard.css';

const SanskritKeyboard = ({ onKeyPress, isVisible, onToggle }) => {
  const [activeTab, setActiveTab] = useState('consonants');

  const consonants = [
    ['क', 'ख', 'ग', 'घ', 'ङ'],
    ['च', 'छ', 'ज', 'झ', 'ञ'],
    ['ट', 'ठ', 'ड', 'ढ', 'ण'],
    ['त', 'थ', 'द', 'ध', 'न'],
    ['प', 'फ', 'ब', 'भ', 'म'],
    ['य', 'र', 'ल', 'व', 'श', 'ष', 'स', 'ह'],
  ];

  const vowels = [
    ['अ', 'आ', 'इ', 'ई', 'उ', 'ऊ'],
    ['ऋ', 'ॠ', 'ऌ', 'ॡ', 'ए', 'ऐ'],
    ['ओ', 'औ', 'अं', 'अः'],
  ];

  const matras = [
    ['ा', 'ि', 'ी', 'ु', 'ू'],
    ['ृ', 'ॄ', 'ॢ', 'ॣ', 'े', 'ै'],
    ['ो', 'ौ', 'ं', 'ः', '्'],
  ];

  const accents = [
    ['॑', '॒', '᳚', '᳛'],
    ['ꣳ', 'ꣴ', '।', '॥'],
  ];

  const special = [
    ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'],
    [' ', '⌫'],
  ];

  const handleKeyClick = (key) => {
    if (key === '⌫') {
      onKeyPress('BACKSPACE');
    } else {
      onKeyPress(key);
    }
  };

  const renderKeyRow = (keys, rowIndex) => (
    <div key={rowIndex} className="sanskrit-keyboard-row">
      {keys.map((key, keyIndex) => (
        <button
          key={keyIndex}
          className={`sanskrit-key ${key === ' ' ? 'space-key' : ''} ${key === '⌫' ? 'backspace-key' : ''}`}
          onClick={() => handleKeyClick(key)}
          type="button"
        >
          {key === ' ' ? 'Space' : key}
        </button>
      ))}
    </div>
  );

  const renderTab = (keys) => (
    <div className="sanskrit-keyboard-keys">
      {keys.map((row, index) => renderKeyRow(row, index))}
    </div>
  );

  if (!isVisible) {
    return (
      <div className="sanskrit-keyboard-toggle">
        <button
          className="keyboard-toggle-btn"
          onClick={onToggle}
          type="button"
        >
          ⌨ संस्कृत-कुञ्जी (Keyboard)
        </button>
      </div>
    );
  }

  return (
    <div className="sanskrit-keyboard">
      <div className="sanskrit-keyboard-header">
        <span className="keyboard-title">संस्कृत-कुञ्जी</span>
        <button
          className="keyboard-close-btn"
          onClick={onToggle}
          type="button"
        >
          ✕
        </button>
      </div>

      <div className="sanskrit-keyboard-tabs">
        <button
          className={`keyboard-tab ${activeTab === 'consonants' ? 'active' : ''}`}
          onClick={() => setActiveTab('consonants')}
          type="button"
        >
          व्यञ्जनानि
        </button>
        <button
          className={`keyboard-tab ${activeTab === 'vowels' ? 'active' : ''}`}
          onClick={() => setActiveTab('vowels')}
          type="button"
        >
          स्वराः
        </button>
        <button
          className={`keyboard-tab ${activeTab === 'matras' ? 'active' : ''}`}
          onClick={() => setActiveTab('matras')}
          type="button"
        >
          मात्राः
        </button>
        <button
          className={`keyboard-tab ${activeTab === 'accents' ? 'active' : ''}`}
          onClick={() => setActiveTab('accents')}
          type="button"
        >
          स्वरचिह्नानि
        </button>
        <button
          className={`keyboard-tab ${activeTab === 'special' ? 'active' : ''}`}
          onClick={() => setActiveTab('special')}
          type="button"
        >
          अन्ये
        </button>
      </div>

      <div className="sanskrit-keyboard-content">
        {activeTab === 'consonants' && renderTab(consonants)}
        {activeTab === 'vowels' && renderTab(vowels)}
        {activeTab === 'matras' && renderTab(matras)}
        {activeTab === 'accents' && renderTab(accents)}
        {activeTab === 'special' && renderTab(special)}
      </div>
    </div>
  );
};

export default SanskritKeyboard;
